import { VGraphData, VGraph } from '@/components/shared/VGraph';
import { ScoreReferenceData } from '@viome/viome-base/src/usecase/Health/Health.model';
interface TrendGraphProps {
  trend: VGraphData[];
  topIndicator: string;
  bottomIndicator: string;
  reverse?: boolean;
  referenceData?: ScoreReferenceData;
}

export const Trends: React.FC<TrendGraphProps> = ({
  trend,
  topIndicator,
  bottomIndicator,
  reverse = false,
  referenceData,
}) => {
  return (
    <div className="mt-6">
      <h1 className="dark text-tertiary typography-h3">Trends</h1>
      <div className="relative h-full w-full">
        <div className="absolute top-2.5 right-2.5 typography-caption1 text-primary">
          <p className="typography-footnote text-tertiary">{topIndicator}</p>
        </div>
        <div className="absolute bottom-12 right-2.5 typography-caption1 text-primary">
          <p className="typography-footnote text-tertiary">{bottomIndicator}</p>
        </div>
        <VGraph
          data={trend}
          height={300}
          reverse={reverse}
          referenceData={referenceData}
        />
      </div>
    </div>
  );
};
